import * as React from 'react';
import * as SwitchPrimitive from '@radix-ui/react-switch';

import { cn } from '@/shared/utils/styling';
import { tv } from 'tailwind-variants';

type Props = React.ComponentProps<typeof SwitchPrimitive.Root> & {
  thumbClassName?: string;
};

const switchClasses = tv({
  slots: {
    container:
      'peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-tertiary focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex h-[2.8rem] w-[6rem] shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer',
    thumb:
      'bg-background pointer-events-none block w-[2rem] h-[2rem] rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[3.6rem] data-[state=unchecked]:translate-x-1',
  },
});

function Switch({ className, thumbClassName, ...props }: Props) {
  const { container, thumb } = switchClasses();

  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      id="switch"
      className={cn(container(), className)}
      {...props}>
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(thumb(), thumbClassName)}
      />
    </SwitchPrimitive.Root>
  );
}

export { Switch };
